import QRCode from "qrcode";
import html2pdf from "html2pdf.js";
import moment from "moment";
import logo from "../../assets/logo.png";
import signatureImage from "../../assets/signature.png";
import { useState, useEffect } from "react";
import PdfPortal from "../layout/pdf-layout";

// Helper to convert image URL to Base64
const imgToBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
};

const fetchImageBase64 = async (url) => {
    const response = await fetch(url, { mode: "cors" });
    const blob = await response.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
};
function convertIsoToLocalDDMMYYYYHHmmss(isoString) {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const year = date.getFullYear();

    const hours = String(date.getHours() + 1).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}

// Pure function: returns HTML string
const htmlStringFunc = (
    data,
    copyName,
    qr,
    logoBase64,
    signatureBase64,
    carImgBase64,
    fitmentImgBase64,
    isSmallDevice
) => {
    return `
<div style="width:185mm;color:#000; ${isSmallDevice?"margin:auto;":"margin:auto;"} font-family:'Times New Roman', Times, serif;">

<div style=" padding-bottom: 5px;">
 <label style="font-size: 13px;"> 
    Date: ${convertIsoToLocalDDMMYYYYHHmmss(data.installation_date)} 
    </label>

    <label style="margin-left: 220px; font-size: 13px;">Installation Certificate</label> </div>
   <!-- ------------------------- HEADER SECTION ------------------------- -->
    <div style="border-collapse: collapse">
      <div>
        <div>
          <label
            style="
              border: 1px solid #1c86c8;
              width: 100%;
              max-width: 100%;
              margin: auto;
              display: flex;
              justify-content: space-between;
              padding-bottom: 5px;
            "
          >
            <img
               src="${logoBase64}"
              style="
                height: 50px;
                margin-left: 1rem;
                margin-top: auto;
                margin-bottom: auto;
                object-fit: contain;
              "
              alt="logo"
            />
            <label>
              <label style="display: flex">
                <table
                  style="
                    margin-top: 0.2rem;
                    margin-bottom: 0.2rem;
                    font-size: 11px;
                  "
                >
                  <div>
                    <tr>
                      <td style="color: blue; font-style: italic">
                        PRICOL LIMITED
                      </td>
                    </tr>
                    <tr>
                      <td style="color: blue; font-style: italic">
                        Passion to Excel
                      </td>
                    </tr>
                    <tr>
                      <td>REGISTERED OFFICE :</td>
                    </tr>
                    <tr>
                      <td>CPM Towers,</td>
                    </tr>
                    <tr>
                      <td>109 Race Course</td>
                    </tr>
                    <tr>
                      <td>Coimbatore 641018, India</td>
                    </tr>
                    <tr>
                      <td>CIN : L33129TZ1972PLC000641</td>
                    </tr>
                  </div>
                </table>
                <table
                  style="
                    margin-left: 4rem;
                    margin-right: 5rem;
                    font-size: 11px;
                    margin-top: 1.2rem;
                    margin-bottom: 1.2rem;
                  "
                >
                  <tbody>
                    <tr>
                      <td style="padding: 0; line-height: 0.2">Plant I,</td>
                    </tr>
                    <tr>
                      <td style="padding: 0; line-height: 0.2">
                        132, Mettupalayam Road,
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0; line-height: 0.2">
                        Perianaickenpalayam,
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0; line-height: 0.2">
                        Coimbatore 641020, India
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0; line-height: 0.2">
                        Phone : +91 4224331100
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0; line-height: 0.2">
                        Email : fms@pricol.co.in
                      </td>
                    </tr>
                  </tbody>
                </table>
              </label>
            </label>
          </label>
        </div>
      </div>
    </div>
    
  <div style="padding-bottom: 5px; width: 100%; font-size: 12px; text-align: end; padding-right:25px;" >
          <span>${copyName} Copy </span>
       </div>
    <!-- ------------------------- HEADER SECTION END ------------------------- -->

      <!-- ------------------------- LIMITATION SECTION ------------------------- -->
    <div>
      <div
        style="
          border: 1px solid #1c86c8;
          width: 100%;
          max-width: 100%;
          /* margin-top: 0.5rem; */
          display: flex;
          justify-content: space-between;
          flex-direction: column;padding-bottom: 10px
        "
      >
        <div>
          <div>
            <div style="height:110px">
              <!-- ------------------------- LIMITATION HEADER WITH QR CODE  ------------------------- -->
              <label
                style="
                  width: 100%;
                  max-width: 100%;
                  display: flex;
                  justify-content: space-between;padding-bottom: 10px;
                "
              >
                <label></label>
                <label
                  style="display: flex; padding: 0.5rem; margin-right: 4.5rem"
                >
                  <label
                    style="
                      font-size: 11px;
                      font-weight: 600;
                      text-align: center;
                      margin-top: auto;
                       margin-bottom: auto;
                    "
                  >
                    <p>ELECTRONIC SPEED LIMITATION DEVICE</p>
                    <p>INSTALLATION CERTIFICATE</p>
                  </label>
    
                  <img
                    src="${qr}"
       
                    style="
                      height: 110px;
                      margin-left: 3rem;
                      margin-top: auto;
                      margin-bottom: auto;
                      object-fit: contain;
                    "
                    alt="logo" /></label>
                    </label>
            </div>
            <!-- ------------------------- DETAILS ------------------------- -->
            <td>
              <label
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  padding-left:10px;
                "
              >
                <table style="width: 40%;  font-size: 11px; margin: 0.2rem">
                  <tbody>
                    <tr>
                      <td>
                        <label
                          style="display: flex; justify-content: space-between"
                        >
                          <label> Certificate No. </label>
                          <label
                            style="
                              width: 50%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : ${data.certificate_no}
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label
                          style="display: flex; justify-content: space-between"
                        >
                          <label> Dealer Name </label>
                          <label
                            style="
                              width: 50%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : ${data.dealer_name}
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label
                          style="display: flex; justify-content: space-between"
                        >
                          <label> Dealer Location </label>
                          <label
                            style="
                              width: 50%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : ${data.dealer_location}
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label
                          style="display: flex; justify-content: space-between"
                        >
                          <label>Dealer Invoice No. </label>
                          <label
                            style="
                              width: 50%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : ${data.dealer_invoice_no}
                          </label>
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table style="width: 40%; font-size: 11px; margin: 0.2rem">
                  <tbody>
                    <tr>
                      <td>
                        <label
                          style="display: flex; justify-content: space-between"
                        >
                          <label> Installation Date </label>
                          <label
                            style="
                              width: 50%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : ${moment(data.installation_date).format(
                                "DD-MMM-YYYY"
                            )}
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label
                          style="display: flex; justify-content: space-between"
                        >
                          <label> SLD Renewal Date </label>
                          <label
                            style="
                              width: 50%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : ${moment(data.sld_renewal_date).format(
                                "DD-MMM-YYYY"
                            )}
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label
                          style="display: flex; justify-content: space-between"
                        >
                          <label> RTO Location </label>
                          <label
                            style="
                              width: 50%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : ${data.rto_location}
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label
                          style="display: flex; justify-content: space-between"
                        >
                          <label> Dealer Invoice Date </label>
                          <label
                            style="
                              width: 50%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : ${moment(data.delear_invoice_date).format(
                                "DD-MMM-YYYY"
                            )}
                          </label>
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table></label
              >
            </td>
            <!-- ------------------------- DETAILS END ------------------------- -->
          </div>
        </div>
      </div>
    </div>
    <!-- ------------------------- LIMITATION SECTION END ------------------------- -->
 
      <!-- ------------------------- ADDRESS SECTION ------------------------- -->
    <tabel>
      <label
        style="
          border: 1px solid #1c86c8;
          width: 100%;
          max-width: 100%;
          margin-top: 0.5rem;
          display: flex;
          justify-content: start;
          flex-direction: column;
          padding-top: 0px;
          padding-bottom: 10px;
        "
      >
        <tbody>
          <tr>
            <!-- ------------------------- DETAILS ------------------------- -->
            <td>
              <label
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                     padding-left:10px;
                "
              >
                <table style="width: 40%; font-size: 11px; margin: 0px">
                  <tbody>
                    <tr>
                      <td>
                        <label style="font-weight: 600">
                          <label>Customer Name & Address : </label>
                        </label>
                        <label
                          style="display: flex; justify-content: space-between"
                        >
                          <label
                            style="
                              width: 85%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                          ${data.customer_name}<br/>${data.customer_address}
                          </label>
                        </label>
                        <label>
                          <label style="font-weight: 600"> Phone </label>
                          <label
                            style="
                              width: 50%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : ${data.customer_phone}
                          </label>
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table style="width: 40%; font-size: 11px">
                  <tbody>
                    <tr>
                      <td>
                        <label style="font-weight: 600">
                          Name & Address of Fitment Center :
                        </label>
                        <label
                          style="display: flex; justify-content: space-between"
                        >
                          <label
                            style="
                              width: 85%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            ${data.fitment_name} <br/> ${data.fitment_address} 
                          </label>
                        </label>
                        <label>
                          <label style="font-weight: 600"> Phone </label>
                          <label
                            style="
                              width: 50%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : ${data.fitment_phone}
                          </label>
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table style="width: 10%; font-size: 11px; padding: 0.1rem ; margin-right: 25px; margin-top:0px;">
                  <tbody>
                    <tr style="padding: 0">
                      <td style="padding: 0">
                        <img
                         src="${carImgBase64}"
                          style="height: 60px; width:60px;object-fit: cover;"
                        />
                      </td>
                    </tr>
                    <tr style="padding: 0">
                      <td style="padding: 0">
                        <img
                          src="${fitmentImgBase64}"
                          style="height: 60px; width:60px;object-fit: cover"
                        />
                      </td>
                    </tr>
                  </tbody></table
              ></label>
            </td>
            <!-- ------------------------- DETAILS END ------------------------- -->
          </tr>
        </tbody>
      </label>
    </tabel>    <!-- ------------------------- ADDRESS SECTION END ------------------------- -->

  <!-- ------------------------- VEHICLE DETAILS SECTION ------------------------- -->
    <tabel>
      <label
        style="
          border: 1px solid #1c86c8;
          width: 100%;
          max-width: 100%;
          margin-top: 0.5rem;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
   
          padding-bottom: 10px
        "
      >
        <tbody>
          <tr>
            <!-- ------------------------- DETAILS ------------------------- -->
            <td>
              <label
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                     padding-left:10px;
                "
              >
                <table style="width: 40%; font-size: 10px; margin: 0.2rem">
                  <tbody>
                    <tr>
                      <td>
                        <label style="display: flex; justify-content: start ;">
                          <label style="width: 130px">
                            Vehicle Make / Model
                          </label>
                          <label
                            style="
                              width: 60%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : <span style="padding-left:5px;"/> ${
                                data.vehicle_make
                            }
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label style="display: flex; justify-content: start">
                          <label style="width: 130px"
                            >Vehicle Reg. No. / Date
                          </label>
                          <label
                            style="
                              width: 60%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : <span style="padding-left:5px;"/>  ${
                                data.vehicle_reg_no
                            }
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label style="display: flex; justify-content: start">
                          <label style="width: 130px">Engine No </label>
                          <label
                            style="
                              width: 60%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : <span style="padding-left:5px;"/> ${
                                data.engine_no
                            }
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label style="display: flex; justify-content: start">
                          <label style="width: 130px"> Chassis No. </label>
                          <label
                            style="
                              width: 60%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : <span style="padding-left:5px;"/>${
                                data.chassis_no
                            }
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label style="display: flex; justify-content: start">
                          <label style="width: 130px"> Roto Seal No. </label>
                          <label
                            style="
                              width: 60%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : <span style="padding-left:5px;"/> ${
                                data.roto_seal_no
                            }
                          </label>
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table style="width: 48%; font-size: 10px; margin: 0.2rem">
                  <tbody>
                    <tr>
                      <td>
                        <label style="display: flex; justify-content: start">
                          <label style="width: 130px"> SLD Model </label>
                          <label
                            style="
                              width: 60%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : <span style="padding-left:5px;"/> ${
                                data.sld_model
                            }
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label style="display: flex; justify-content: start">
                          <label style="width: 130px"> SLD ECU No. </label>
                          <label
                            style="
                              width: 60%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : <span style="padding-left:5px;"/> ${
                                data.sld_ecu_no
                            }
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label style="display: flex; justify-content: start">
                          <label style="width: 130px">
                            SLD Motor Unit / Solenoid No.
                          </label>
                          <label
                            style="
                              width: 60%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : <span style="padding-left:5px;"/> ${
                                data.sld_motor_unit
                            }
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label style="display: flex; justify-content: start">
                          <label style="width: 130px">
                            Speed Sensor Type
                          </label>
                          <label
                            style="
                              width: 60%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : <span style="padding-left:5px;"/> ${
                                data.speed_sensor_type
                            }
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label style="display: flex; justify-content: start">
                          <label style="width: 130px">Test Report No. </label>
                          <label
                            style="
                              width: 60%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : <span style="padding-left:5px;"/> ${
                                data.test_report_no
                            }
                          </label>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label style="display: flex; justify-content: start">
                          <label style="width: 130px">TAC No. </label>
                          <label
                            style="
                              width: 60%;
                              text-align: start;
                              color: #0000ff;
                            "
                          >
                            : <span style="padding-left:5px;"/> ${data.tac_no}
                          </label>
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table></label
              >
            </td>
            <!-- ------------------------- DETAILS END ------------------------- -->
          </tr>
        </tbody>
      </label>
    </tabel>
    <!-- ------------------------- VEHICLE DETAILS SECTION END ------------------------- -->

  <!-- ------------------------- DESCRIPTION SECTION ------------------------- -->
    <tabel style=" margin-top:25px; margin-bottom:25px;">

        <tbody style=" margin-top:25px; margin-bottom:25px;">
          <tr>
            <td>
                  <label
        style="
          border: 1px solid #1c86c8;
          width: 100%;
          max-width: 100%;
          font-size: 12px;
          margin-top: 0.5rem;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          font-size : 12px ;
          padding-left: 0.4rem;
          padding-right: 0.4rem;
        "
      >
              <label style="padding: 0.4rem">
                This is to certify that the above mentioned vehicle has been
                fitted with PRICOL make Speed Limitation Device (SLD) which is
                set to a maximum speed of
                <span style="color: #0000ff">${
                    data.speed_limit
                }</span> Kmph (+/- 2%) and shall
                not exceed the set speed in any circumstance unless the SLD is
                tampered with. This SLD is tested, calibrated, sealed and
                certified by our Authorised person/agency/dealer on
                <span style="color: #0000ff">${moment(
                    data.certifiacte_date
                ).format("DD-MMM-YYYY")}</span>.
              </label>
                 <label style="padding: 0.4rem;">
                We certify that the above-mentioned SLD has been installed
                calibrated and sealed at <span style="color: #0000ff">'${
                    data.points
                }'</span> points as per CMVR norms. This
                certificate is issued to the customer only after calibration,
                testing and sealing.
              </label>
              <label style="padding: 0.4rem;">
                The above-mentioned vehicle fitted with Pricol make SLD is
                handed over to the vehicle owner in good working condition and
                to the entire satisfaction of the vehicle owner/driver.
                Henceforth, it is the sole responsibility of the vehicle owner
                for proper working of SLD and in no way Pricol is held
                responsible for any tampering or non-functioning of SLD at any
                point of time after issuance of this certificate.
              </label>
              <label style="padding: 0.4rem;">
                <p style="border-bottom: 1.5px solid;padding-bottom: 0.6rem; margin-bottom:10px;">
                  General Information : Please write to "fms@pricol.co.in" or
                  contact '04224331100', if any grievances/ violations are
                  observed with fitment of Pricol make SLD and its documents.
                </p>
              </label>
              </label>
            </td>
          </tr>
        </tbody></tabel
    >
    <!-- ------------------------- DESCRIPTION SECTION END ------------------------- -->

  <!-- ------------------------- TABLE SECTION ------------------------- -->
    <table style=" width: 100%; border-spacing: 2px;  margin-top:7px; border-collapse: separate; ">
      <thead style="height:30px !important;">
        <tr>
          <th
            style="
              border: 1px solid #1c86c8;
              font-size: 11px;
              width: 25%;

              justify-content: center;
              text-align: center;
              vertical-align: top;
             padding-top:0px !important;
              margin-top:0px !important;
              padding-bottom:0px !important;
            "
          >
        <p style="
             padding-top:0px !important;
              margin-top:-4px !important;
              padding-bottom:0px !important;
            ">
          For Customer
          </p>
            
          </th>
          <th
            style="
              border: 1px solid #1c86c8;
              font-size: 11px;
              width: 25%;
                     text-align: center; 
              vertical-align: top;
             padding-top:0px !important;
              margin-top:0px !important;
              padding-bottom:0px !important;
            "
          >
            <p style="
             padding-top:0px !important;
              margin-top:-5px !important;
              padding-bottom:0px !important;
              line-height:12px;
            ">
            For Dealer/Authorised Fitment Centre
            </p>
          </th>
          <th
            style="
              border: 1px solid #1c86c8;
              font-size: 11px;
              width: 25%;
                      text-align: center; 
              vertical-align: top;
             padding-top:0px !important;
              margin-top:0px !important;
              padding-bottom:0px !important;
            "
          >
            <p style="
             padding-top:0px !important;
              margin-top:-4px !important;
              padding-bottom:0px !important;
            ">
            For Pricol Limited
            </p>
          </th>
          <th
            style="
              border: 1px solid #1c86c8;
              font-size: 11px;
              width: 25%;
                      text-align: center; 
              vertical-align: top;
             padding-top:0px !important;
              margin-top:0px !important;
              padding-bottom:0px !important;
            "
          >
            <p style="
             padding-top:0px !important;
              margin-top:-4px !important;
              padding-bottom:0px !important;
            ">
            For Transport Dept.
            </p>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            style="
              border: 1px solid #1c86c8;
              font-size: 11px;
              width: 25%;
              padding-left: 1rem;
              padding-top: 0.2rem;
            "
          ></td>
          <td
            style="
              border: 1px solid #1c86c8;
              font-size: 11px;
              width: 25%;
              padding-left: 1rem;
              padding-top: 0.2rem;
            "
          ></td>
          <td
            style="
              border: 1px solid #1c86c8;
              font-size: 11px;
              width: 25%;
              padding-left: 1rem;
              padding-top: 0.2rem;
              text-align: center;
            "
          >
            <img 
             src="${signatureBase64}"
            style="height: 35px" alt="signature" />
          </td>
          <td
            style="
              border: 1px solid #1c86c8;
              font-size: 11px;
              width: 25%;
              padding-left: 1rem;
              padding-top: 0.2rem;
            "
          ></td>
        </tr>
        <tr  style="height:22px;   text-align: center; 
              vertical-align: top;">
          
          <td
            style="
              border: 1px solid #1c86c8;
              font-size: 11px;
              text-align: center; 
              vertical-align: top;
             padding-top:0px !important;
              margin-top:0px !important;
              padding-bottom:0px !important;
            "
          >
           <p style="
             padding-top:0px !important;
              margin-top:-5px !important;
              padding-bottom:0px !important;
            ">
            Name & Designation
            </p>
          </td>
          <td
            style="
              border: 1px solid #1c86c8;
              font-size: 11px;
                 text-align: center; 
              vertical-align: top;
            padding-top:0px !important;
              margin-top:0px !important;
              padding-bottom:0px !important;
            "
          >
          <p style="
             padding-top:0px !important;
           margin-top:-5px !important;
              padding-bottom:0px !important;
            ">
            Name & Designation
            </p>
          </td>
          <td
            style="
              border: 1px solid #1c86c8;
              font-size: 11px;

                text-align: center; 
              vertical-align: top;
              padding-top:0px !important;
              margin-top:0px !important;
              padding-bottom:0px !important;
            "
          >
            <p style="
             padding-top:0px !important;
              margin-top:-5px !important;
              padding-bottom:0px !important;
            ">Authorised Signatory<p>
          </td>
          <td
            style="
              border: 1px solid #1c86c8;
              font-size: 11px;
                text-align: center; 
             padding-top:0px !important;
              margin-top:0px !important;
              padding-bottom:0px !important;
            "
          >
           <p style="
             padding-top:0px !important;
            margin-top:-5px !important;
              padding-bottom:0px !important;
            ">
            Authorised Signatory</p>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- ------------------------- TABLE SECTION END ------------------------- -->
</div>

</div>
`;
};

// Component
export default function CertificatePDF({ data }) {
    const [qrCode, setQrCode] = useState("");
    const [logoBase64, setLogoBase64] = useState("");
    const [signatureBase64, setSignatureBase64] = useState("");
    const [carImgBase64, setCarImgBase64] = useState("");
    const [fitmentImgBase64, setFitmentImgBase64] = useState("");
    const [loading, setLoading] = useState(true);

    // Generate QR code
    useEffect(() => {
        const generateQR = async () => {
            try {
                const text = `MFG by:${data.customer_name},Cert No:${
                    data.certificate_no
                },Dt:${moment(data.installation_date).format(
                    "DD-MM-YYYY"
                )},Veh Rg.No:${data.vehicle_reg_no},Chas.No:${
                    data.chassis_no
                },Eng.No:${data.engine_no},SLD ECU No:${
                    data.sld_ecu_no
                },Speed:${data.speed_limit}`;
                const qr = await QRCode.toDataURL(text);
                setQrCode(qr);
            } catch (err) {
                console.error("QR code generation error:", err);
            }
        };
        generateQR();
    }, [data]);

    // Convert logo to Base64
    useEffect(() => {
        const fetchLogo = async () => {
            const base64 = await imgToBase64(logo);
            setLogoBase64(base64);
        };
        const fetchSignature = async () => {
            const signaturbase64 = await imgToBase64(signatureImage);
            setSignatureBase64(signaturbase64);
        };
        fetchLogo();
        fetchSignature();
    }, []);

    useEffect(() => {
        const fetchImages = async () => {
            if (data.car_img) {
                setCarImgBase64(await fetchImageBase64(data.car_img));
            }
            if (data.fitment_image) {
                setFitmentImgBase64(await fetchImageBase64(data.fitment_image));
            }
            setLoading(false);
        };
        fetchImages();
    }, [data]);
        const isSmallDevice = window.innerWidth < 768;

    const handleDownload = () => {
        if (carImgBase64 == "" || fitmentImgBase64 == "") {
            return;
        }
        const element = document.getElementById("pdf-html-container");
        html2pdf()
            .from(element)
            .set({
                margin: isSmallDevice ? [10, 0, 0, 0] : [25, 15, 15, 5],
                filename: `${data.customer_name || "certificate"}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: {  dpi: 300,scale: 2, windowWidth: 1440,  scrollY: 0,scrollX: 0},
                jsPDF: { unit: "px", format:"a4", orientation: "portrait", hotfixes : ["px_scaling"]},
            })
            .save();
    };

    return (
        <>
            <button
                onClick={handleDownload}
                style={{
                    padding: "8px 12px",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    borderRadius: "4px",
                    marginBottom: "10px",
                }}
            >
                {loading ? "please wait pdf is generating" : "Download PDF"}
            </button>

            {logoBase64 && qrCode && (
               <PdfPortal>
                    <div
                        id="pdf-html-container"
                        dangerouslySetInnerHTML={{
                            __html: `

                            <style>
                              no-break {
                                page-break-inside: avoid;
                                break-inside: avoid;
                              }
                              table.print-friendly tr td {
                                page-break-inside: avoid;
                              }
                            </style>
              ${htmlStringFunc(
                  data,
                  "Customer",
                  qrCode,
                  logoBase64,
                  signatureBase64,
                  carImgBase64,
                  fitmentImgBase64,
                  isSmallDevice
              )}
              <div class="no-break" style="page-break-before: always;"></div>
              ${htmlStringFunc(
                  data,
                  "Department",
                  qrCode,
                  logoBase64,
                  signatureBase64,
                  carImgBase64,
                  fitmentImgBase64,
                  isSmallDevice
              )}
              <div class="no-break" style="page-break-before: always;"></div>
              ${htmlStringFunc(
                  data,
                  "Dealer",
                  qrCode,
                  logoBase64,
                  signatureBase64,
                  carImgBase64,
                  fitmentImgBase64
              )}
              <div class="no-break" style="page-break-before: always;"></div>
              ${htmlStringFunc(
                  data,
                  "Manufacturers",
                  qrCode,
                  logoBase64,
                  signatureBase64,
                  carImgBase64,
                  fitmentImgBase64,
                  isSmallDevice
              )}
            `,
                        }}
                    ></div>
                </PdfPortal> 
            )}
        </>
    );
}
